import React from "react";
import { useAuth } from "../Provider/AuthProvider";
import { Navigate } from "react-router";

export default function PrivateRoute({children}: any) {
  const auth = useAuth();

  return auth.currentUser ? children : <Navigate to="/Login" />
};